<template>
  <div class="addNewFeed">
    <addnewtypeheader-com
      :plural="plural"
      :singular="singular"
      :dataTypes="dataTypes"
    ></addnewtypeheader-com>
    <contentgroup-com>
      <div class="addNewFeed-column">
        <div class="addNewFeed-name">Plural <span>- ex. Pages</span></div>
        <div class="addNewFeed-field">
          <input type="text" v-model="plural" placeholder="...">
        </div>
      </div>
      <div class="addNewFeed-divider"></div>
      <div class="addNewFeed-column">
        <div class="addNewFeed-name">Singular <span>- ex. Page</span></div>
        <div class="addNewFeed-field">
          <input type="text" v-model="singular" placeholder="...">
        </div>
      </div>
    </contentgroup-com>
    <contentgroup-com marginBottom="300">
      <datatypes-com :currentDataTypes="dataTypes" @dataTypes="setDataTypes($event)"></datatypes-com>
    </contentgroup-com>
  </div>
</template>

<script>

import AddnewtypeheaderCom from '@/components/AddNewTypeHeader'
import DatatypesCom from '@/components/DataTypes'

export default {
  components: {
    AddnewtypeheaderCom,
    DatatypesCom
  },
  methods: {
    setDataTypes (dataTypes) {
      this.dataTypes = dataTypes
    }
  },
  computed: {
    feeds () {
      return this.$store.state.feeds
    },
    feed () {
      const currentFeed = this.$store.state.currentFeed
      return this.$store.state.feeds[currentFeed]
    }
  },
  data () {
    return {
      plural: '',
      singular: '',
      dataTypes: []
    }
  },
  created () {
    this.plural = this.feed[0].plural
    this.singular = this.feed[0].singular
    this.dataTypes = this.feed[0].template
  }
}
</script>

<style lang="sass">
@import './../sass/core.sass'

+block('addNewFeed')
  width: 100%
  height: calc(100% + 70px)

  +element('column')
    width: 100%

  +element('divider')
    width: 25px

  +element('name')
    padding-top: 9px
    padding-left: 25px
    text-transform: capitalize
    font-size: 12px
    margin-bottom: 12px

    span
      opacity: .5

</style>



// WEBPACK FOOTER //
// src/routerViews/AddNewFeed.vue